export const inventoryKeyParam = 'inventoryKey';
